import {
  DataObjectId,
  DeadlineStickerEntry,
  Hub,
  ObjectType
} from 'yougile-model'
import {DeadlineStatus} from '@components/aggregated/types'
import {TableDataType} from '@components/common/base/table/types'

export enum TimelineScale {
  Days = 'days',
  Weeks = 'weeks',
  Months = 'months',
  Years = 'years'
}

export const timelineScales = [
  TimelineScale.Days,
  TimelineScale.Weeks,
  TimelineScale.Months,
  TimelineScale.Years
]

type Interval = number
type PxPerInterval = number
export type TimelineScaleData = [Interval, PxPerInterval]

export enum ColumnId {
  title = 'title',
  assigned = 'assigned',
  dateRange = 'date-range',
  length = 'length',
  menu = 'menu'
}

export interface RowData extends TableDataType<string> {
  path: string
  hubId: DataObjectId
  hub?: Hub
  expandable: boolean
  level: number
  type: ObjectType
  hue: number
  parentId: DataObjectId
  completed?: boolean
  draggable?: boolean
  linkable?: boolean
  report?: boolean
  mirror?: boolean
  isSubtask?: boolean
}

export interface LinkData {
  fromPath: string
  toPath: string
  fromSwimlane: number
  toSwimlane: number
}

export interface Point {
  x: number
  y: number
}

export interface VerticalStripeData {
  timestamp: number
  length: number
}

export interface CutoffData {
  timestamp: number
  title: string
  border?: boolean
}

export interface DeadlineItem {
  deadline: DeadlineStickerEntry
  completed: boolean
}

export interface ItemData {
  deadline: DeadlineStatus
  row: RowData
}

export enum DeadlineState {
  Planned = 'planned',
  InProgress = 'in-progress',
  Expired = 'expired'
}

export interface EnhancedDragData {
  rowId: DataObjectId | string

  position: 'before' | 'after'

  draggedHubId: DataObjectId

  /**
   * An id of a real object to drop before/after. `undefined` means insert at the top/bottom of the whole list.
   */
  overHubId?: DataObjectId

  /**
   * An id of a parent of an `overHubId` object. `undefined` means insert a column into a board at the top/bottom of the whole list.
   */
  intoHubId?: DataObjectId

  /**
   * An id of a previous parent object. Used to remove from parent subtasks.
   */
  prevParentHubId?: DataObjectId

  /**
   * - If `overHubId` is defined, `overPosition` points to where to insert relative to `overHubId`.
   * - If `overHubId` is not defined, `'before'` means insert at the beginning, `'after'` means insert at the end.
   */
  overPosition: 'before' | 'after'
}
